import { render, staticRenderFns } from "./SeriesPreviewQuestions.vue?vue&type=template&id=48bea9c6&"
import script from "./SeriesPreviewQuestions.vue?vue&type=script&lang=js&"
export * from "./SeriesPreviewQuestions.vue?vue&type=script&lang=js&"
import style0 from "./SeriesPreviewQuestions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports